import "core-js/modules/es.string.replace.js";

/**
 * Calculator
 *
 * This component requires jQuery.
 * You can require it on the page using <div data-component="calculator"></div>
 */
$(function () {
  $('[data-component="calculator"]').each(function () {
    $('#mortgage-calculator input[type=checkbox]').change(function () {
      $('#mortgage-calculator #' + $(this).attr('id') + '_target').toggle();
    });
    $('#mortgage-calculator select').change(function () {
      var selection = $(this).find('option:selected').data('value');
      $($('#mortgage-calculator #' + selection + '_target').parent('.field_wrap').find('.hidden_field').hide());
      $('#mortgage-calculator #' + selection + '_target').show();
    });
    $('#mortgage-calculator input[type=text], #mortgage-calculator input[type=number]').keyup(function () {
      var annualIncome = 0;
      var monthlyIncome = 0;
      var incomeAfterCommitments = 0;
      var disposableIncome = 0;
      var term = 0;
      var loanSum = 0;
      var maxPurchasePrice = 0;

      if ($('#mortgage-calculator input[name=wealth]:visible').val()) {
        annualIncome = parseInt($('#mortgage-calculator input[name=wealth]:visible').val());

        if ($('#mortgage-calculator input[name=partner_wealth]:visible').val()) {
          annualIncome += parseInt($('#mortgage-calculator input[name=partner_wealth]:visible').val());
        }
      }

      monthlyIncome = annualIncome / 12;

      if ($('#mortgage-calculator input[name=commitments]').val()) {
        incomeAfterCommitments = monthlyIncome - parseInt($('#mortgage-calculator input[name=commitments]').val());
      } else {
        incomeAfterCommitments = monthlyIncome;
      }

      if ($('#mortgage-calculator input[name=monthly_costs]').val()) {
        disposableIncome = incomeAfterCommitments - parseInt($('#mortgage-calculator input[name=monthly_costs]').val());
      } else {
        disposableIncome = incomeAfterCommitments;
      }

      if ($('#mortgage-calculator input[name=term]').val()) {
        term = $('#mortgage-calculator input[name=term]').val();
      }

      if (term > 19) {
        loanSum = disposableIncome * 12 * 4.5;
      } else if (term > 14 && term < 20) {
        loanSum = disposableIncome * 12 * 4.25;
      } else if (term > 9 && term < 15) {
        loanSum = disposableIncome * 12 * 4;
      } else if (term > 4 && term < 10) {
        loanSum = disposableIncome * 12 * 2.5;
      } else if (term > 0 && term < 5) {
        loanSum = disposableIncome * 12 * 0.75;
      }
      /*
      console.log('Annual Income: '+annualIncome);
      console.log('Monthly Income: '+monthlyIncome);
      console.log('Income after commitments: '+incomeAfterCommitments);
      console.log('Disposable Income: '+disposableIncome);
      console.log('Term: '+term);
      console.log('Loan Sum: '+loanSum);
      */


      if (loanSum >= 0) {
        // $('#loan_sum').text('£'+Math.floor(loanSum).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","));
        $('#loan_sum').text('£' + Math.floor(parseFloat(loanSum)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      } else {
        $('#loan_sum').text('£0');
      }
    });
  });
});